import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c6a376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "SKU编码：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入SKU编码：",
                      value: _ctx.modelRef.skuCode,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.skuCode) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "申报中文品名：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入申报中文品名",
                      value: _ctx.modelRef.declareNameCn,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.declareNameCn) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      style: {"margin-left":"10px"},
                      onClick: _ctx.addNewSku
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增SKU")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      style: {"width":"100%"},
      rowKey: "id",
      columns: _ctx.columns,
      dataSource: _ctx.list,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      size: "small",
      scroll: {x: 'calc(100vw + 80%)'},
      "row-selection": _ctx.rowSelection,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({column,text,record}) => [
        (column.dataIndex === 'declareNumber')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.isflag)
                ? (_openBlock(), _createBlock(_component_a_input_number, {
                    key: 0,
                    id: "inputNumber",
                    value: record.declareNumber,
                    "onUpdate:value": ($event: any) => ((record.declareNumber) = $event),
                    min: 1,
                    precision: 0,
                    onBlur: ($event: any) => (_ctx.handleChangeNumber(record))
                  }, null, 8, ["value", "onUpdate:value", "onBlur"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(text), 1))
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'dHeight')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(record.length +'*'+ record.width +'*'+ record.height), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'rHeight')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(record.realLength +'*'+ record.realWidth +'*'+ record.realHeight), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'hasBattery')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'hasBattery')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading", "pagination", "scroll", "row-selection", "onChange"]),
    _createVNode(_component_a_row, { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.handleModal,
          "html-type": "submit",
          style: {"margin-left":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}